import EditProductHeader from '@/components/Products/EditProductHeader';
import { useFetchProductById } from '@/hooks/useFetchProductById';
import LayoutInside from '@/layout/LayoutInside';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';

export default function EditLayout({
  children,
}: {
  children?: React.ReactNode;
}) {
  const { t } = useTranslation(['common', 'routes']);

  const { id } = useParams<{ id: string }>();

  const pathSegments = location.pathname.split('/').filter(Boolean);
  const lastSegment = pathSegments[pathSegments.length - 1];

  const { product, isLoadingProductDetail } = useFetchProductById(id);


  const breadcrumbItems = [
    { text: t('products'), link: '/products' },
    {
      text: t('edit_product'),
      link: `/products/edit-product/${id}/geral`,
    },
    {
      text: t(`routes:${lastSegment.toLowerCase()}`),
      link: `/products/edit-product/${id}/${lastSegment}`,
    },
  ];

  return (
    <LayoutInside hasBgBlur items={breadcrumbItems}>
      <EditProductHeader product={product} isLoading={isLoadingProductDetail} />
      {!isLoadingProductDetail && (
        <Outlet context={{ product, isLoadingProductDetail }} />
      )}
      <section className='m-auto h-full max-w-[1032px] md:px-10 xl:px-0 w-full mb-16'>
        {children}
      </section>
    </LayoutInside>
  );
}
